import React, { useState } from "react";
import styles from "./BottomNavbar.module.css";

import { PiPhoneCall } from "react-icons/pi";
import { RiHome6Line, RiHome6Fill, RiSearchLine } from "react-icons/ri";
import { HiOutlineClipboardList, HiClipboardList } from "react-icons/hi";
import { FaUser, FaRegUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { LuPhoneCall } from "react-icons/lu";
import { TbMessageChatbot } from "react-icons/tb";
import { MdOutlineWhatsapp } from "react-icons/md";
import { IoClose } from "react-icons/io5";
// import FloatingSupportMenuMobile from '../FloatingSupportMenu/FloatingSupportMenuMobile';
export default function BottomNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
 
  return (
    <>
      <div className={styles.bottombox}>
        <div className={styles.nav_item} onClick={()=>navigate('/')}>
          <RiHome6Line className={styles.nav_icon}  />
          <span className={styles.nav_text} >Home</span>
        </div>
        <div className={styles.nav_item} onClick={()=>navigate('/Search')}>
          <RiSearchLine className={styles.nav_icon}   />
          <span className={styles.nav_text} >Search</span>
        </div>
        <div className={styles.nav_item}>
          <div
            style={{
              width: 55,
              height: 55,
              backgroundColor: "#fff",
              marginTop: -39,
              marginBottom: 5,
              borderRadius: 100,
              padding: 5,
            }}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <div
              style={{
                background: "#07448E",
                width: "100%",
                height: "100%",
                borderRadius: 100,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0px 1px 1px 1px rgba(0,0,0,0.5)",
              }}
            >
              <PiPhoneCall color="#fff" size={23} />
            </div>
          </div>

          <span className={styles.nav_text}>Call</span>
        </div>
        <div className={styles.nav_item} onClick={()=>navigate('/Order')}>
          <HiOutlineClipboardList className={styles.nav_icon}   />
          <span className={styles.nav_text} >Order</span>
        </div>
        <div className={styles.nav_item} onClick={() =>navigate("/SignIn")}>
          <FaRegUser className={styles.nav_icon} />
          <span className={styles.nav_text} >Profile</span>
        </div>
        {menuOpen && (
          <div
            style={{
              width: "100%",
              height: 150,
              position: "absolute",
              bottom: 90,
              transition:"5s ease"
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  width: 25,
                  height: 25,
                  background: "#000",
                  borderRadius: 100,
                  flexDirection: "column",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={()=>setMenuOpen(!menuOpen)}
              >
                <IoClose color="#fff" />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: 10,
                  width: "70%",
                  flexDirection: "row",
                  marginTop: 20,
                }}
              >
                <div
                  style={{
                    width: 50,
                    height: 50,
                    background: "#2563eb",
                    borderRadius: 100,
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LuPhoneCall size={20} color="#fff" />
                </div>

                <div
                  style={{
                    width: 50,
                    height: 50,
                    background: "#FFAA00",
                    borderRadius: 100,
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <TbMessageChatbot size={20} color="#fff"/>
                </div>

                <div
                  style={{
                    width: 50,
                    height: 50,
                    background: "#25D366",
                    borderRadius: 100,
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MdOutlineWhatsapp size={20} color="#fff"/>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* <FloatingSupportMenuMobile open={menuOpen} onClose={() => setMenuOpen(false)}/> */}
    </>
  );
}
